import { render, staticRenderFns } from "./ProductEditor.vue?vue&type=template&id=0e21bea2&"
import script from "./ProductEditor.vue?vue&type=script&lang=js&"
export * from "./ProductEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditor.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports